// extracted by mini-css-extract-plugin
module.exports = {"link":"LegalLinks_link__hZD78"};